import axios from "axios";
import settings from "../settings";
import router from "@/router";

const entryTypes = ["debit", "credit"];
const infoProviders = ["eugesta", "smarten", "odoo"];

let newRuleData = {
    is_new: true,
    description: null,
    info_provider: "eugesta",
    start_date: null,
    end_date: null,
    percent: 0,
    amount: null,
    client_id: null,
    export_client_id: null,
    store_id: null,
    tag_id: null,
    entry_type: "debit"
};
let initialState = {
    loadingRuleList: false,
    loadingRuleData: false,
    requestSuccess: false,
    requestError: false,
    drawerOpen: false,
    activeRule: {},
    rules: [],
    searchRuleString: "",
    errorMessage: "",
    infoProviders: infoProviders,
    entryTypes: entryTypes,
    ruleCount: 0
};

export default {
    namespaced: true,
    state: {...initialState},
    actions: {
        async getRuleList({commit}, search = null) {
            await commit("setRuleListLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/rules", {params: search});
                if (response?.data?.success === 1) {
                    let data = response.data;
                    await commit("addRules", data.rules);
                    await commit("setRuleCount", data.total_rules_count);
                }
            } catch (e) {
                console.log(e);
            }
            await commit("setRuleListLoading", false);
        },
        async getRuleData({commit}, ruleId) {
            commit("setRuleDataLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/rule/" + ruleId);
                if (response.data?.success === 1) {
                    let data = response.data;
                    commit("setActiveRule", data.rule_data);
                }
            } catch (e) {
                console.log(e);
            }
            commit("setRuleDataLoading", false);
        },
        async submitRuleUpdate({commit, dispatch}, payload) {
            await commit("setRequestSuccess", false);
            await commit("setErrorMessage", "");
            await commit("setRuleDataLoading", true);
            try {
                let response = await axios.post(settings.api_url + "/rule/", payload);
                if (response.status === 200 && response.data.success === 1) {
                    await dispatch("getRuleList");
                    await commit("setRequestSuccess", true);
                }
            } catch (e) {
                console.log(e);
            }
            await commit("setRuleDataLoading", false);
        },
        async deleteRule({commit, dispatch}, {ruleId}) {
            await commit("setRequestSuccess", false);
            await commit("setErrorMessage", "");
            await commit("setRuleListLoading", true);
            try {
                let response = await axios.delete(settings.api_url + "/rule/", {params: {rule_id: ruleId}});
                if (response && response.data.success === 1) {
                    await dispatch("getRuleList");
                    await commit("setRequestSuccess", true);
                } else if (response.data.success === 0) {
                    await commit("setRequestError", true);
                    await commit("setErrorMessage", "Failed");
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
            commit("setRuleListLoading", false);
            router.push("/rules");
        },
        async applyRulesToSales({commit}, payload) {
            await commit("setRequestSuccess", false);
            await commit("setRequestError", false);
            await commit("setErrorMessage", "");
            try {
                let response = await axios.get(settings.api_url + "/apply-rules",);
                if (response.status === 200 && response.data.success === 1) {
                    await commit("setRequestSuccess", true);
                } else if (response.data.success === 0) {
                    await commit("setRequestError", true);
                    await commit("setErrorMessage", response.data.msg || "Failed");
                }
            } catch (e) {
                await commit("setRequestError", true);
                await commit("setErrorMessage", "Failed");
            }
        },
        async importExcel({commit, dispatch}, e) {
            await commit("setRuleListLoading", true);
            let formData = new FormData();
            formData.append("file", e);
            await commit("setRequestSuccess", false);
            await commit("setRequestError", false);

            try {
                let response = await axios.post(settings.api_url + "/rules-excel/", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });

                if (response.status === 200) {
                    if (response.data.success === 1) {
                        await commit("setRequestSuccess", true);
                    } else {
                        await commit("setRequestError", true);
                        await commit("setErrorMessage", response.data.error_msg || "Failed");
                    }
                }
            } catch (e) {
                console.log(e);
                await commit("setRequestError", true);
                await commit("setErrorMessage", "Failed");
            }

            await commit("setRuleListLoading", false);
            await dispatch("getRuleList");
        },
    },
    mutations: {
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setRequestError(state, bool) {
            state.requestError = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        addRules(state, rules) {
            state.rules = rules;
        },
        setActiveRule(state, rule) {
            state.activeRule = {...rule};
        },
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        resetActiveRule(state) {
            state.activeRule = {};
        },
        addNewRule(state) {
            state.activeRule = {...newRuleData};
        },
        updateActiveRuleProperty(state, {prop, value}) {
            state.activeRule = {
                ...state.activeRule,
                [prop]: value
            };
        },
        updateRuleSearch(state, payload) {
            state.searchRuleString = payload.term;
            this.dispatch("RuleStore/getRuleList", {
                search: state.searchRuleString
            });
        },
        resetRuleSearch(state) {
            state.searchRuleString = "";
        },
        setRuleListLoading(state, value) {
            state.loadingRuleList = value;
        },
        setRuleDataLoading(state, value) {
            state.loadingRuleData = value;
        },
        setRuleCount(state, value) {
            state.ruleCount = value;
        }
    }
};
